/* eslint @typescript-eslint/no-duplicate-enum-values: off */

export enum IconSize {
    Small = 11,
    Medium = 16,
    M_large = 20,
    Medium_25 = 25,
    Large = 32,
    Big = 38,
    Big_45 = 45,
    Huge = 60,
    Mega = 120,
    // Edge cases that should probably be phased out
    EDGECASE_ReportHeaderLogo = 52,
    EDGECASE_PersonDetailsReferenceIcon = 52,
    // Due to differences in icon design, these edgecase require unique values to appear the same size
    EDGECASE_TeamConfigIcon = 80.28,
    EDGECASE_TeamConfigIconAnimation = 119.58,
    EDGECASE_StratConfigIcon = 102
    /*
        This should be removed and replaced by icon fontsize classes that can be optionaly added when instatiating the component:
        <abstract-icon icon="send-email-group" class="icon-fontSizeClassNameThatIsOptional"></abstract-icon>
    */
}
